// Mock data for contact form submissions

export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', formData);
      const submission = {
        id: Date.now(),
        ...formData,
        timestamp: new Date().toISOString(),
        status: 'received'
      };
      
      // Store in localStorage for demo purposes
      const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
      submissions.push(submission);
      localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
      
      resolve({
        success: true,
        message: 'Thank you for contacting us! We will get back to you soon.',
        data: submission
      });
    }, 800);
  });
};

export const storeHours = {
  weekdays: 'Monday - Friday: 5:00 AM - 11:00 PM',
  weekends: 'Saturday - Sunday: 6:00 AM - 11:00 PM'
};

export const contactInfo = {
  address: '704 Main St, Hope, Indiana',
  phone: '(812) 546-5780',
  googleMapsLink: 'https://www.google.com/maps/search/?api=1&query=704+Main+St+Hope+Indiana'
};
